import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-47828166")

_pushScopeId("data-v-47828166")
const _hoisted_1 = {
  key: 0,
  class: "drop-icon"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "fal fa-sign-in fa-rotate-90 fa-6x" }, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "control"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "status" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-spinner fa-spin fa-2x" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("  Uploading... ")
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle fa-2x error" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("div", {
    class: ['file-drag-and-drop', _ctx.disabled ? 'disabled' : ''],
    onDragover: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createVNode("div", {
      class: "drop-panel",
      onDrop: _cache[4] || (_cache[4] = (...args) => (_ctx.droppedFiles && _ctx.droppedFiles(...args))),
      onDragover: _cache[5] || (_cache[5] = (...args) => (_ctx.dragover && _ctx.dragover(...args))),
      onDragleave: _cache[6] || (_cache[6] = (...args) => (_ctx.dragleave && _ctx.dragleave(...args)))
    }, [
      _createVNode("input", {
        type: "file",
        style: {"display":"none"},
        ref: "fileSelector",
        accept: ".pdf",
        multiple: "",
        name: 'file-input'+_ctx.id,
        id: 'file-input'+_ctx.id,
        onChange: _cache[1] || (_cache[1] = (...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
        disabled: _ctx.disabled
      }, null, 40, ["name", "id", "disabled"]),
      (!_ctx.error && !_ctx.uploading)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      (!_ctx.error && !_ctx.uploading)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (!_ctx.uploading && !_ctx.error && _ctx.selectedFiles.length == 0)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode("span", {
                    class: "text-btn",
                    onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.selectFile && _ctx.selectFile(...args))),
                    tabindex: "0"
                  }, "Choose a file"),
                  _hoisted_4,
                  (_ctx.dragAndDropCapable)
                    ? (_openBlock(), _createBlock("span", _hoisted_5, "or drag it here."))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.disabled)
              ? (_openBlock(), _createBlock("span", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "disabled-message", {}, undefined, true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedFiles.length)
              ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.selectedFiles.length) + " file(s) selected ", 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_8, [
        (_ctx.uploading)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_9,
              _hoisted_10
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_11,
              _createTextVNode("  " + _toDisplayString(_ctx.errorMsg.join(' | ')) + " ", 1),
              _createVNode("span", {
                style: {"flex":"1 100%"},
                class: "text-btn",
                onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.tryAgain && _ctx.tryAgain(...args))),
                tabindex: "0"
              }, "Try Again")
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ], 34))
})